import howToAddANomineeInIndia from './how-to-add-a-nominee-in-india';
import whatIsANominee from './what-is-a-nominee';
import whyNomineesStillNeedToBeTold from './why-nominees-still-need-to-be-told';

export const BLOG_PATH = '/blog';

export const AUTHOR = {
  name: 'KeepMyAsset Team',
  url: 'https://www.keepmyasset.com/about',
};

const posts = [whatIsANominee, whyNomineesStillNeedToBeTold, howToAddANomineeInIndia];

function wordCount(text) {
  return String(text || '')
    .replace(/:::\w+[^\n]*/g, '')
    .replace(/!\[.*?\]\(.*?\)/g, '')
    .split(/\s+/)
    .filter(Boolean).length;
}

function withDefaults(post) {
  const minutes = Math.max(3, Math.round(wordCount(post.body) / 200));
  return {
    author: AUTHOR,
    readTime: `${minutes} min read`,
    ...post,
  };
}

export const blogPosts = posts.map(withDefaults);

const bySlug = Object.fromEntries(blogPosts.map((post) => [post.slug, post]));

export function getAllPosts() {
  return [...blogPosts].sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));
}

export function getPostBySlug(slug) {
  return bySlug[slug] || null;
}

export function getRelatedPosts(post) {
  return (post.related || []).map((slug) => bySlug[slug]).filter(Boolean);
}

export function getPostPath(slug) {
  return `${BLOG_PATH}/${slug}`;
}
